import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../../store';
import {ActivatedRoute} from "@angular/router";
import {CloudflareService} from "../../../../services/cloudflare.service";
import {NotifierComponent} from "../../../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../../shared/components/notifier/notification-type";
import {filter, first, map, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
    selector: 'db-cdn-full-page-cache-toggle',
    templateUrl: './cdn-full-page-cache-toggle.component.html',
    styleUrls: ['./cdn-full-page-cache-toggle.component.scss'],
    standalone: false
})
export class CdnFullPageCacheToggleComponent implements OnInit {

  public websiteId: number;
  public loading = true;
  public cdnDisabled = true;
  public pageCacheDisabled = true;

  private readonly _destroyStream = new Subject<boolean>();

  constructor(
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _route: ActivatedRoute,
    private readonly _cdr: ChangeDetectorRef,
    private _cloudflareService: CloudflareService
  ) { }

  ngOnInit() {
    this.websiteId = +this._route.snapshot.parent.parent.params['id'];
    this._getCloudflareData();
/*    this._getCloudFlareFullPageCacheDisabled();
    this._getCloudFlareEnterPriseDisabled();*/
  }

  private _getCloudflareData(): void {
    this._store.select(fromStore.getCloudflareData(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream),
        filter(({cacheRules}) => !!cacheRules),
        map(({cacheRules}) => cacheRules),
      )
      .subscribe(({disableCdn, disablePageCache}) => {
        this.cdnDisabled = disableCdn;
        this.pageCacheDisabled = disablePageCache;
        this.loading = false;
        this._cdr.markForCheck();
      });
  }


  /*private _getCloudFlareFullPageCacheDisabled(): void {
    this._store.select(fromStore.getCloudFlareFullPageCacheDisabled(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream),
      )
      .subscribe(state => {
        this.pageCacheDisabled = !!state;
      });
  }

  private _getCloudFlareEnterPriseDisabled(): void {
    this._store.select(fromStore.getCloudFlareEnterPriseDisabled(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream),
      )
      .subscribe(state => {
        this.cdnDisabled = !!state;
      })
  }*/

  public togglePageCache(state: boolean): void {
    this.loading = true;
    this._cloudflareService.cacheToggle(this.websiteId, state)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        if (response.success) {
          this.loading = false;
          this._store.dispatch(new fromStore.SetFullPageCacheDisabled(
            {
              websiteId: this.websiteId,
              fullPageCacheDisabled: !!state
            }));
          NotifierComponent.notify(new Notification(`Page Cache ${state ? 'Disabled' : 'Enabled'}`, NotificationType.SUCCESS));
        } else {
          NotifierComponent.notify(new Notification('Something Went Wrong...', NotificationType.DANGER));
        }
      });
  }
}
